import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../../reducers/uiSlice';

function SlotSelect(props) {
    const dispatch = useDispatch();
    const {account, driverSlotsPair, manualEdit, createSlotConfiguration, withSlot, staffs, updateWithSlot, clear, resetClear, handleExistSlot, existSlot, zone} = props;
    const {t} = useTranslation('slotAssignment');
    
    const slotManagement = useSelector(state => state.saReducer);

    const [slotNo, setSlotNo] = useState('')
    const [slotArray, setSlotArray] = useState([]);
    const [driverSlotsPairCopy, setDriverSlotsPairCopy] = useState({});
    const [firstTime, setFirstTime] = useState(true);

    const handleSlotNoChange = (event) => {       
        let exist = false;
        for(var key in existSlot) {
            if(existSlot[key].slotNo + '' === event.target.value + '' && key !== account.id && existSlot[key].zone + '' === zone + '' && event.target.value) {
                exist = true;
                dispatch(showAlertSnackbar({message: t('duplicated_slot_no'), type: 'warning'}))
                setSlotNo('');
                createSlotConfiguration(account.id, undefined);        
                if(existSlot[account.id]) {
                    if(existSlot[account.id].slotId) {
                        withSlot[staffs]--;
                        handleExistSlot(account.id, undefined, undefined);
                    }                    
                }
                break;
            }
        }        
        if(!exist) {
            // choose empty slot no or not
            if(slotNo && !event.target.value) {
                withSlot[staffs]--;
                handleExistSlot(account.id, undefined, undefined);
                createSlotConfiguration(account.id, undefined);
            } else {
                createSlotConfiguration(account.id, event.target.value);
                handleExistSlot(account.id, event.target.value, zone);
                if(!withSlot[staffs] && event.target.value) {
                    withSlot[staffs] = 1;
                } else if(!slotNo && event.target.value) {
                    withSlot[staffs]++;
                }
            }        
            setSlotNo(event.target.value);
            updateWithSlot(withSlot);
        }
    }

    useEffect(() => {      
        if(driverSlotsPairCopy[account.id]) {
            setSlotNo(driverSlotsPairCopy[account.id]);
            createSlotConfiguration(account.id, driverSlotsPairCopy[account.id]);
            handleExistSlot(account.id, driverSlotsPairCopy[account.id], zone);
        } else {
            setSlotNo('');
        }
        setFirstTime(true);
    }, [driverSlotsPairCopy])

    useEffect(() => {
        setSlotNo('');
        setSlotArray([]);
        let array = [''];
        if(slotManagement.getWarehouseTotalSlots !== 0) {
            for(var i = 1; i <= slotManagement.getWarehouseTotalSlots; i++) {
                array.push(i)
            }
            setSlotArray(array)
        }
        setFirstTime(true);
    }, [slotManagement.getWarehouseTotalSlots])

    useEffect(() => {
        if(clear) {
            setSlotNo(``);
            setDriverSlotsPairCopy('');
            createSlotConfiguration(account.id, undefined);
            handleExistSlot(account.id, undefined, undefined);
            updateWithSlot({});
            resetClear();
            setFirstTime(false);
        } else if(firstTime) {
            setDriverSlotsPairCopy(driverSlotsPair);
        }       
    }, [clear])

    useEffect(() => {
        if(driverSlotsPair) {
            setDriverSlotsPairCopy(driverSlotsPair);
        }
    }, [driverSlotsPair])

    return (
        <div>
            <Select
                variant="outlined"
                disabled={manualEdit}
                value={ slotNo || ``}
                onChange={handleSlotNoChange}
            >
                {
                    slotArray.map((slot) => {
                        return <MenuItem value={slot} style={{ height: 40 }}>{slot}</MenuItem>
                    })
                }
            </Select>
        </div>        
    )
}

export default SlotSelect;